class Product {
  constructor(element) {
    this.element = element;

    this.image = this.element.querySelector(".product-image");
    this.video = this.element.querySelector(".collection-grid__video");
    this.imageWrapper = this.element.querySelector(".collection-grid__image-wrapper");
    this.titleLink = this.element.querySelector(".home-page-collection__item-title");
    this.price = this.element.querySelector(".product-price");
    this.compare = this.element.querySelector(".compare-price");
    this.variants = this.element.querySelectorAll(".variant-radio");
    this.variantWrappers = this.element.querySelectorAll(".variant-wrapper");
    this.productTitleLink = this.element.querySelector(".product-title");

    this.newBadge = this.element.querySelector(".new-badge");
    this.soldBadge = this.element.querySelector(".sold-badge");
    this.limitedBadge = this.element.querySelector(".limited-badge");
    this.availableMonths = this.element.querySelector(".available-months");
    this.preOrderBadge = this.element.querySelector(".pre-order-badge");

    this.hoverImage = this.element.querySelector(".hover-image");

    this.defaultImageSrc = this.image ? this.image.src : "";
    this.defaultHoverImageSrc = this.hoverImage ? this.hoverImage.src : "";
    this.defaultVariantName = "";

    if (this.imageWrapper) {
      this.imageWrapper.addEventListener("mouseover", this.handleImageWrapperMouseOver.bind(this));
      this.imageWrapper.addEventListener("mouseout", this.handleImageWrapperMouseOut.bind(this));
    }

    this.addEventListeners();

    if (this.video) {
      this.addVideoEventListeners();
    }

    const selectedVariant = Array.from(this.variants).find((v) => v.checked);
    if (selectedVariant) {
      this.updateVariant(selectedVariant);
    }
  }

  ensureHoverImage() {
    if (!this.hoverImage && this.imageWrapper) {
      const img = document.createElement("img");
      img.className = "collection-grid__image collection-products__card-image hover-image";
      img.alt = "";
      img.style.display = "none";
      this.imageWrapper.appendChild(img);
      this.hoverImage = img;
    }
  }

  setHoverImageSrc(src) {
    this.ensureHoverImage();
    if (!this.hoverImage) return; 
    if (src && typeof src === "string" && src.trim().length > 0) {
      this.hoverImage.src = src;
      this.hoverImage.style.display = "";
    } else {
      this.hoverImage.removeAttribute("src");
      this.hoverImage.style.display = "none";
    }
  }

  handleImageWrapperMouseOver() {
    const selectedVariant = Array.from(this.variants).find((v) => v.checked);
    const hoverSrc = selectedVariant && selectedVariant.getAttribute("data-hover-image");

    if (hoverSrc) {
      this.imageWrapper && this.imageWrapper.classList.add("hovered");
      this.updateHoverImage();
    }
  }

  handleImageWrapperMouseOut() {
    this.imageWrapper && this.imageWrapper.classList.remove("hovered");
    this.resetImageToDefault();
  }

  addEventListeners() {
    this.variantWrappers.forEach((wrapper, index) => {
      const variant = this.variants[index];
      if (!variant) return;

      wrapper.addEventListener("mouseover", () => {
        this.previewVariantImage(variant);
        if (variant.hasAttribute("data-hover-image")) {
          wrapper.classList.add("hovered");
        }
      });

      wrapper.addEventListener("mouseout", () => this.resetImageToDefault());
      variant.addEventListener("change", () => this.updateVariant(variant));
    });
  }

  addVideoEventListeners() {
    if (!this.imageWrapper) return;
    this.imageWrapper.addEventListener("mouseover", () => this.playVideo());
    this.imageWrapper.addEventListener("mouseout", () => this.stopVideo());
  }

  playVideo() {
    if (!this.video || !this.image) return;
    this.image.classList.add("hidden-element");
    this.video.classList.remove("hidden-element");
    if (this.video.tagName === "VIDEO") this.video.play();
  }

  stopVideo() {
    if (!this.video || !this.image) return;
    this.image.classList.remove("hidden-element");
    this.video.classList.add("hidden-element");
    if (this.video.tagName === "VIDEO") this.video.pause();
  }

  previewVariantImage(variant) {
    if (this.image && variant.getAttribute("data-image")) {
      this.image.src = variant.getAttribute("data-image");
    }

    const variantWrapper = variant.closest(".variant-wrapper");
    if (variantWrapper) {
      variantWrapper.classList.add("hovered");
    }
    this.variantWrappers.forEach((w) => {
      if (w !== variantWrapper) w.classList.add("not-hovered");
    });

    this.toggleBadges(variant);
  }

  resetImageToDefault() {
    if (this.image && this.defaultImageSrc) {
      this.image.src = this.defaultImageSrc;
    }

    this.variantWrappers.forEach((w) => {
      w.classList.remove("hovered", "not-hovered");
    });

    const variantNameElement = this.element.querySelector(".item-variant-name");
    if (variantNameElement) {
      variantNameElement.textContent = this.defaultVariantName || "";
    }

    const selectedVariant = Array.from(this.variants).find((v) => v.checked);
    this.toggleBadges(selectedVariant);

    this.setHoverImageSrc(""); 
  }

  updateVariant(variant) {
    const imgSrc = variant.getAttribute("data-image");
    if (this.image && imgSrc) {
      this.defaultImageSrc = imgSrc;
      this.image.src = imgSrc;
    }

    const hoverSrc = variant.getAttribute("data-hover-image");
    if (hoverSrc) {
      this.setHoverImageSrc(hoverSrc);
      this.defaultHoverImageSrc = hoverSrc;
    } else {
      this.setHoverImageSrc("");
      this.defaultHoverImageSrc = "";
    }

    const variantNameElement = this.element.querySelector(".item-variant-name");
    if (variantNameElement) {
      const name = variant.getAttribute("variant-name") || "";
      variantNameElement.textContent = name;
      this.defaultVariantName = name;
    }

    const variantUrl = variant.getAttribute("data-url");
    if (variantUrl) {
      const productTitleLinks = this.element.querySelectorAll(".product-title");
      productTitleLinks.forEach((link) => (link.href = variantUrl));

      const shopNowButton = this.element.querySelector(".home-page-collection__button");
      if (shopNowButton) shopNowButton.href = variantUrl;

      if (this.imageWrapper && this.imageWrapper.tagName === "A") {
        this.imageWrapper.href = variantUrl;
      }
      if (this.titleLink && this.titleLink.tagName === "A") {
        this.titleLink.href = variantUrl;
      }

      const productItemLink = this.element.closest(".home-page-collection__item.product-item");
      if (productItemLink && productItemLink.tagName === "A") {
        productItemLink.href = variantUrl;
      }
    }

    if (this.video && variant.getAttribute("data-video")) {
      const videoSrc = variant.getAttribute("data-video");
      const sources = this.video.getElementsByTagName("source");
      if (sources.length > 0) {
        for (let i = 0; i < sources.length; i++) sources[i].src = videoSrc;
        this.video.load();
      } else {
        this.video.src = videoSrc;
      }
    }

    this.updatePrice(variant);
    this.toggleBadges(variant);
  }

  updateHoverImage() {
    const selectedVariant = Array.from(this.variants).find((v) => v.checked);
    if (!selectedVariant) return;

    const hoverSrc = selectedVariant.getAttribute("data-hover-image");
    if (hoverSrc) {
      this.setHoverImageSrc(hoverSrc);
    } else if (this.defaultHoverImageSrc) {
      this.setHoverImageSrc(this.defaultHoverImageSrc);
    } else {
      this.setHoverImageSrc("");
    }
  }

  toggleBadges(variant) {
    if (this.newBadge) {
      this.newBadge.style.display = variant && variant.hasAttribute("new") ? "block" : "none";
    }
    if (this.soldBadge) {
      this.soldBadge.style.display = variant && variant.hasAttribute("sold-out") ? "block" : "none";
    }
    if (this.limitedBadge) {
      this.limitedBadge.style.display = variant && variant.hasAttribute("limited") ? "block" : "none";
    }
    if (this.availableMonths) {
      if (variant && variant.hasAttribute("available-months")) {
        this.availableMonths.style.display = "block";
        this.availableMonths.textContent = variant.getAttribute("available-months");
      } else {
        this.availableMonths.style.display = "none";
      }
    }
    if (this.preOrderBadge) {
      this.preOrderBadge.style.display = variant && variant.hasAttribute("pre-order") ? "block" : "none";
    }
  }

  updatePrice(variant) {
    if (!variant || !this.price) return;

    const nextPrice = variant.getAttribute("data-price") || "";
    const nextCompare = (variant.getAttribute("data-compare") || "").trim();
    const hasCompare = nextCompare.length > 0;

    this.price.textContent = nextPrice;

    if (this.compare) {
      this.compare.textContent = nextCompare;
      this.compare.style.display = hasCompare ? "" : "none";
    }

    const priceWrapper = this.element.querySelector(".product-price-wrapper");
    if (priceWrapper) {
      priceWrapper.setAttribute("data-wpd-variant-id", variant.value);
      priceWrapper.setAttribute("data-wpd-variant-price", variant.getAttribute("data-price-raw") || "");
      priceWrapper.setAttribute("data-wpd-variant-compare-at-price", variant.getAttribute("data-compare-raw") || "");
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll(".product-item");
  products.forEach((product) => new Product(product));
});

document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll(".collection-products__card");
  const customFilters = document.querySelectorAll(".custom-filter__radio");

  function applyFilterByType(selectedType) {
    const typeLower = selectedType.toLowerCase();
    products.forEach((product) => {
      const productType = product.getAttribute("data-type")?.toLowerCase();
      product.style.display = productType === typeLower ? "flex" : "none";
    });
  }

  function updateURLParam(type) {
    const params = new URLSearchParams(window.location.search);
    params.set("type", type.toLowerCase());
    const newUrl = window.location.pathname + "?" + params.toString();
    window.history.replaceState({}, "", newUrl);
  }

  customFilters.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selectedType = this.getAttribute("data-type");
      applyFilterByType(selectedType);
      updateURLParam(selectedType);
    });
  });

  const params = new URLSearchParams(window.location.search);
  const typeParam = params.get("type");
  if (typeParam) {
    const selectedRadio = Array.from(customFilters).find(
      (radio) => radio.getAttribute("data-type")?.toLowerCase() === typeParam.toLowerCase()
    );
    if (selectedRadio) {
      selectedRadio.checked = true;
      applyFilterByType(selectedRadio.getAttribute("data-type"));
    }
  }
});
